export const GET_SUS = 'GET_SUS';

// Get SUS (via saga)
export const getSUS = (locationType = 'input', startLat, startLng) => {
	return {
		type: 'GET_SUS',
		options: {
			locationType,
			startLat,
			startLng
		}
	}
}

// Put SUS (from saga)
export const putSUS = (sus = []) => {
	return {
		type: 'PUT_SUS',
		payload: {
			sus,
		}
	}
}

// Clear SUS
export const clearSUS = (sus = []) => {
	return {
		type: 'CLEAR_SUS',
		payload: {
			sus,
		}
	}
}



// WEBPACK FOOTER //
// ./src/actions/sus.js